import Vue from 'vue';
import { EventBus } from '@/event-bus';

export default Vue.extend({
  methods: {
    closeStepperWrapper(): void {
      EventBus.$emit('closeStepperWrapper');
    },
  },
});
